import React from 'react';
import loadable from '@loadable/component';

import withPage, { fetchSlugInfo } from '../page';
import { Helpers } from '../core/src/helpers';

const ConfigurePage = loadable(() => import('./components'));
const CONFIG_PARAMS = {
    langId: 1,
    catalogId: 1,
    storeId: 1,
    quantity: 1,
    catEntryId: 1,
    color: 1,
    configCatentryId: 1,
};

const derivedSlug = (match, search) => {
    const {
        params: { dir, slug, slugTwo, filters },
    } = match;
    const queryString = Helpers.paramsToString(search, true, CONFIG_PARAMS);
    return `${slug ? slug : ''}${slugTwo ? `/${slugTwo}` : ''}${queryString ? `?${queryString}` : ''}`;
};

const derivedPath = (match, search) => {
    const {
        params: { dir, slug, slugTwo, filters },
    } = match;
    const queryString = Helpers.paramsToString(search, true, CONFIG_PARAMS);
    return `${dir}/${slug ? slug : ''}${slugTwo ? `/${slugTwo}` : ''}${queryString ? `?${queryString}` : ''}`;
};

export const loadData = async (urlParams, store, querySelector) => {
    const { dir, slug } = urlParams;
    const queryString = Helpers.paramsToString(querySelector, true, CONFIG_PARAMS);
    const fullSlug = `${dir ? `${dir}/` : ''}${slug ? slug : ''}${queryString ? `?${queryString}` : ''}`;
    await store.dispatch(fetchSlugInfo(fullSlug, { useGraphQL: true }));

    const { slugInfo, redirects, basename } = store.getState();

    const needRedirect = !slugInfo || slugInfo.error || (redirects && redirects.count !== 0);

    const { destination = `${basename}/slp/weekly-deals`, status = 301 } = redirects;
    if (needRedirect) return Promise.resolve({ status, destination });

    return Promise.resolve(slugInfo);
};

const ConfigureContainer = () => {
    return <ConfigurePage />;
};

export default {
    component: withPage(ConfigureContainer, {
        wrapperClassName: 'configure-root',
        showWordCloud: true,
        useV2: true,
        useGraphQL: true,
        derivedSlug,
        derivedPath,
    }),
    loadData,
};
